export default "__VITE_ASSET__DlZVQQaf__"